import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <div className="footer">
      <p>copyright Ⓒ Genmovies | All rights reserved</p>
    </div>
  );
}
